<template>
  <ResearchTeam :isTestPortal="true"></ResearchTeam>
</template>
<script>
import ResearchTeam from "./research-team.vue";

export default {
  name: "test-portal-research-team",
  components: {
    ResearchTeam
  }
};
</script>
